import { SecretVerificationRequest } from "./secretVerificationRequest";

export class UpdateTwoFactorWebAuthnDeleteRequest extends SecretVerificationRequest {
  id: number;
}
